import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  SESSION_FEATURE_KEY,
  SessionState,
  sessionAdapter,
} from './session.reducer';
import { selectRouteParam } from '@lyceo/shared/data-access';
import { CallState, LoadingState } from '@lyceo/shared/util-loading';

export const selectSessionState =
  createFeatureSelector<SessionState>(SESSION_FEATURE_KEY);

const { selectEntities } = sessionAdapter.getSelectors();

export const selectSessions = createSelector(
  selectSessionState,
  (state: SessionState) => selectEntities(state),
);

export const selectSelectedSessionId = createSelector(
  selectSessionState,
  (state: SessionState) => state.selectedSessionId,
);

export const selectSelectedSession = createSelector(
  selectSessions,
  selectSelectedSessionId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined),
);

export const selectDirectLinkParam = selectRouteParam('directLink');

export const selectSessionCallState = createSelector(
  selectSessionState,
  (state: SessionState) => state.sessionCallState,
);

export const selectSessionLoading = createSelector(
  selectSessionCallState,
  (callState: CallState) => callState === LoadingState.LOADING,
);
